<div class="balance-box">
  <h2 class="ui-headline txt-center">{{ 'new_strategy.risk_screen.slider.active.' + riskName | translate }}</h2>
  <div class="ratio-holder">
    <p class="stock">
      <span class="ratio">{{ stockRatio | translatePercent: customer.language : 0 }}</span>
      <span>{{ 'new_strategy.risk_screen.slider.stocks' | translate }}</span>
    </p>
    <p class="bond">
      <span class="ratio">{{ bondRatio | translatePercent: customer.language : 0 }}</span>
      <span>{{ 'new_strategy.risk_screen.slider.bonds' | translate }}</span>
    </p>
  </div>
  <div class="slider-holder">
    <div class="slider">
      <input
        class="slide-dot"
        type="range"
        (input)="updateValue($event)"
        [max]="maxSliderValue.toString()"
        [min]="minSliderValue.toString()"
        [ngClass]="{ insufficient: insufficient }"
        [value]="pickedValue"
      />
      <div class="recommended-border" [ngClass]="recommendedClass"></div>
      <label class="recommended-label" for="slide_dot_recommended" id="text" [ngClass]="recommendedClass">
        {{ 'risk.box.recommended_short' | translate }}
      </label>
      <div *ngIf="insufficient" class="insufficient-knowledge" [ngClass]="[customer.language, riskName]">
        {{ 'new_strategy.risk_screen.slider.insufficientknowledge' | translate }}
      </div>
    </div>
    <div class="original-tooltip" [ngClass]="initialRiskName" *ngIf="recheck">
      <span class="triangle"></span>
      <p>{{ 'new_strategy.notifications.risk_recheck.tooltip.p1' | translate }}</p>
      <p>{{ 'new_strategy.notifications.risk_recheck.tooltip.p2' | translate: { stocks: initialStock, bonds: initialBond } }}</p>
    </div>
  </div>
</div>
